/**
 * Fetches the address otpon
 * @param {string} input - the input to search for
 * @param {{resolve: (value: any) => void, reject: (value: any) => void}} def - the outer promise to resolve or reject
 * @param {Object} autocompleteService - the google maps autocomplete service
 * @param {Object} placesService - the google maps places service
 */
export const fetchAddressOptions = (
  input,
  def,
  autocompleteService,
  placesService
) => {
  const types = ["address"];
  autocompleteService.getPlacePredictions(
    { input, types },
    (results, status) => {
      if (!results || status !== "OK") return [];
      const res = results.map((placeResult) => {
        const p = new Promise((resolve, reject) => {
          const place_id = placeResult.place_id;
          placesService.getDetails(
            {
              placeId: place_id,
              fields: ["address_components", "formatted_address", "geometry"],
            },
            (placeDetails, status) => {
              if (status === "OK") {
                resolve(placeDetails);
              } else {
                reject();
              }
            }
          );
        });
        return p;
      });

      Promise.allSettled(res).then((placeDetails) => {
        def.resolve(
          placeDetails
            .filter((place) => place.status === "fulfilled")
            .map((place) => place.value)
        );
      });
    }
  );
};
